module.exports = __webpack_public_path__ + "media/sword1.3b6df08e.wav";